import * as React from 'react';
import { Box, LinearProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { getPendingHttpRequests, subscribeHttpLoading } from '../../services/httpLoadingTracker';

export const HttpLoadingBar: React.FC = () => {
  const pendingRequests = React.useSyncExternalStore(
    subscribeHttpLoading,
    getPendingHttpRequests,
    getPendingHttpRequests
  );
  const [isVisible, setIsVisible] = React.useState(pendingRequests > 0);
  const hideTimeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    if (pendingRequests > 0) {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      setIsVisible(true);
      return;
    }

    hideTimeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      hideTimeoutRef.current = null;
    }, 100);

    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
  }, [pendingRequests]);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme => theme.zIndex.tooltip + 1,
        pointerEvents: 'none',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 180ms ease',
      }}
    >
      <LinearProgress
        sx={{
          height: 4,
          filter: 'blur(2px)',
          backgroundColor: 'transparent',
          '& .MuiLinearProgress-bar1Indeterminate': {
            animationDuration: '4.5s',
            backgroundColor: 'transparent',
            backgroundImage: theme =>
              `linear-gradient(to right, ${alpha(theme.palette.primary.main, 0)} 0%, ${alpha(theme.palette.primary.main, 0.9)} 20%, ${alpha(theme.palette.primary.main, 0.9)} 80%, ${alpha(theme.palette.primary.main, 0)} 100%)`,
          },
          '& .MuiLinearProgress-bar2Indeterminate': {
            animationDuration: '4.5s',
            backgroundColor: 'transparent',
            backgroundImage: theme =>
              `linear-gradient(to right, ${alpha(theme.palette.primary.main, 0)} 0%, ${alpha(theme.palette.primary.main, 0.9)} 20%, ${alpha(theme.palette.primary.main, 0.9)} 80%, ${alpha(theme.palette.primary.main, 0)} 100%)`,

          },
        }}
      />
    </Box>
  );
};

